/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface GetAppointmentExclusionResponse
 */
export interface GetAppointmentExclusionResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetAppointmentExclusionResponse
     */
    id: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {Date}
     * @memberof GetAppointmentExclusionResponse
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentExclusionResponse
     */
    startTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentExclusionResponse
     */
    endTime: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAppointmentExclusionResponse
     */
    reason: string | null;
}

/**
 * Check if a given object implements the GetAppointmentExclusionResponse interface.
 */
export function instanceOfGetAppointmentExclusionResponse(value: object): value is GetAppointmentExclusionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function GetAppointmentExclusionResponseFromJSON(json: any): GetAppointmentExclusionResponse {
    return GetAppointmentExclusionResponseFromJSONTyped(json, false);
}

export function GetAppointmentExclusionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppointmentExclusionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['id']),
        'date': (new Date(json['date'])),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'reason': json['reason'],
    };
}

export function GetAppointmentExclusionResponseToJSON(json: any): GetAppointmentExclusionResponse {
    return GetAppointmentExclusionResponseToJSONTyped(json, false);
}

export function GetAppointmentExclusionResponseToJSONTyped(value?: GetAppointmentExclusionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetLastSelectedIdParameterToJSON(value['id']),
        'date': value['date'].toISOString().substring(0,10),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'reason': value['reason'],
    };
}

